import { Box, CircularProgress } from "@mui/material"
import type { FC } from "react"

export const InstructionsLoading: FC = () => (
  <Box className='flex size-full items-center justify-center'>
    <CircularProgress />
  </Box>
)
